import $ from "jquery"

/**
 * Define values for key codes
 * @public object
 */
export const keyCodes = {
	tab: 9,
	enter: 13,
	esc: 27,
	space: 32,
	pageup: 33,
	pagedown: 34,
	end: 35,
	home: 36,
	left: 37,
	up: 38,
	right: 39,
	down: 40,
}

/**
 * Define values for key directions
 * @public object
 */
export const keyDirections = {
	37: -1,
	38: -1,
	39: 1,
	40: 1,
}

let accessibilityInstance = null

class Accessibility {
	constructor() {
		if (accessibilityInstance) {
			return accessibilityInstance
		}

		$("body").addClass("key-mode")

		this._boundOnTabFocus = this._onTabFocus.bind(this)
		$(document).on("keydown mousedown", this._boundOnTabFocus)

		accessibilityInstance = this
	}

	_onTabFocus(e) {
		if (e.code === "Tab") {
			document.body.classList.add("key-mode")
		}

		if (e.type === "mousedown") {
			document.body.classList.remove("key-mode")
		}
	}

	_getFocusableElements(container) {
		return $(container)
			.find(
				`
            a[href],
            area[href],
            iframe,
            [tabindex]:not([tabindex="-1"]),
            [contenteditable],
            input:not([type="hidden"]):not([disabled]),
            select:not([disabled]),
            textarea:not([disabled]),
            button:not([disabled])
        `,
			)
			.filter(":visible")
			.not("[inert], [inert] *")
	}

	initOverlay(container) {
		const handler = (event) => {
			const firstEl = this.getFirstFocusableElement(container)
			const lastEl = this.getLastFocusableElement(container)
			if (!firstEl || !lastEl) return

			// TODO: somehow we need to find out if this overlay is inside of another overlay so the ancestor-overlay do not handle focus if child-overlay is currently in use
			let isOverlayInbetween = false
			container
				.querySelectorAll(".bb-overlay-wrapper")
				.forEach((ov) => (isOverlayInbetween = ov.contains(event.target) ? true : isOverlayInbetween))
			if (isOverlayInbetween) return

			this.handleInteraction(event, {
				onTab: (e) => {
					if (e.target === lastEl) {
						e.preventDefault()
						firstEl.focus()
					}
				},
				onShiftTab: (e) => {
					if (e.target === firstEl) {
						e.preventDefault()
						lastEl.focus()
					}
				},
			})
		}

		container.addEventListener("keydown", handler)
		return handler
	}

	destroyOverlay(container, handler) {
		container.removeEventListener("keydown", handler)
	}

	handleInteraction(
		event,
		{
			onClick,
			onTab,
			onShiftTab,
			onArrowDown,
			onArrowUp,
			onArrowLeft,
			onArrowRight,
			onEnter,
			onEscape,
			onHome,
			onEnd,
		},
	) {
		if (event.pointerType || event.type === "click") {
			onClick?.(event)
			return
		}

		switch (event.key) {
			case "Enter":
				onEnter?.(event)
				onClick?.(event)
				break
			case " ":
				onClick?.(event)
				break
			case "Tab":
				event.shiftKey ? onShiftTab?.(event) : onTab?.(event)
				break
			case "ArrowDown":
				onArrowDown?.(event)
				break
			case "ArrowUp":
				onArrowUp?.(event)
				break
			case "ArrowLeft":
				onArrowLeft?.(event)
				break
			case "ArrowRight":
				onArrowRight?.(event)
				break
			case "Home":
				onHome?.(event)
				break
			case "End":
				onEnd?.(event)
				break
			case "Escape":
				onEscape?.(event)
				break
		}
	}

	getFirstFocusableElement(container) {
		return this._getFocusableElements(container).first().get(0)
	}

	getLastFocusableElement(container) {
		return this._getFocusableElements(container).last().get(0)
	}
}

export default Accessibility
